import Sortable from 'sortablejs'

export const useSortUtil = {
  /**
   * 表格拖拽排序工具
   * @param {Object} options 配置项
   * @param {string} options.tableSelector 表格选择器
   * @param {string} options.draggable 拖拽元素选择器
   * @param {string} options.handle 拖拽把手选择器
   * @param {Function} options.callback 回调函数
   * @param {Object} options.options 其他配置项
   * @returns {Promise<Sortable|null>} 返回Promise,resolve Sortable实例或null
   */
  initTableSort: ({
    tableSelector = '.table-sortable .el-table__body-wrapper tbody',
    draggable = 'tr',
    handle = '.table-drop-item',
    callback = null,
    ...options
  }) => {
    const table = document.querySelector(tableSelector)
    return table
      ? Sortable.create(table, {
          animation: 200,
          draggable,
          handle,
          ghostClass: 'sortable-ghost',
          chosenClass: 'sortable-chosen',
          dragClass: 'sortable-drag',
          ...options,
          // 拖拽结束后的处理
          onEnd(obj) {
            if (callback && typeof callback === 'function') {
              callback(obj)
            }
          }
        })
      : null
  },

  /**
   * 排序
   * @param {Array} dataList 数据列表
   * @param {Object} val 排序对象
   * @returns {Array} 返回排序后的数据列表
   */
  sort: (dataList, val) => {
    const { newIndex, oldIndex } = val
    const list = [...dataList]
    const currRow = list.splice(oldIndex, 1)[0]
    list.splice(newIndex, 0, currRow)
    return list
  },

  /**
   * 销毁排序实例
   * @param {Sortable} instance Sortable实例
   */
  destroy: instance => {
    if (instance && typeof instance.destroy === 'function') {
      instance.destroy()
    }
  }
}
